'use client'
import { useContext } from 'react'
import { PageTransitionContext } from '@/context/project/PageTransitionContext'

export const usePageTransition = () => {
  const { transitionName, setTransitionName } = useContext(PageTransitionContext) || {}
  return { transitionName, setTransitionName }
}
